import { cloneElement, Component } from 'react';
import keyCodes from '@insight/toolkit-utils/lib/types/keyCodes';
import { CustomTypes } from '../../utils';

export default class KeyboardAccessible extends Component {
  onKeyDown = (e) => {
    const { children } = this.props;
    if (e.keyCode === keyCodes.SPACE) {
      e.preventDefault();
    }
    if (children.props.onKeyDown) {
      children.props.onKeyDown(e);
    }
  };

  onKeyUp = (e) => {
    const { children } = this.props;
    if (e.keyCode === keyCodes.ENTER || e.keyCode === keyCodes.SPACE) {
      children.props.onClick(e);
    }

    if (children.props.onKeyUp) {
      children.props.onKeyUp(e);
    }
  };

  applyKeyboardAccessibility(child) {
    const props = {
      tabIndex: '0',
      role: 'button',
      ...child.props,
      onKeyDown: this.onKeyDown,
      onKeyUp: this.onKeyUp,
    };

    return cloneElement(child, props);
  }

  render() {
    return this.applyKeyboardAccessibility(this.props.children);
  }
}

KeyboardAccessible.propTypes = {
  children: CustomTypes.keyboardInaccessibleElement,
};
KeyboardAccessible.defaultProps = {
  children: null,
};
